import {createContext, use} from 'react'
import {buildCommentSnapshot, type CommentSnapshot} from '@github-ui/pull-requests/helpers/comment-snapshot'

// Default used when a CCR suggestion subtree is rendered without a provider
// (e.g. isolated component tests). Production always renders the provider from
// AutomatedReviewThreadComment with the real snapshot.
const FALLBACK_COMMENT_SNAPSHOT: CommentSnapshot = buildCommentSnapshot({author: null, createdAt: '', bodyHTML: ''})

const CommentSnapshotContext = createContext<CommentSnapshot>(FALLBACK_COMMENT_SNAPSHOT)

/**
 * Provides the source comment's snapshot to the CCR suggestion subtree so the
 * add-to-batch leaf can build a unified batch item without prop drilling.
 * `commentSnapshot` is optional (the thread builds it only when the feature is
 * enabled); absent, consumers fall back to the context default.
 */
export function CommentSnapshotProvider({
  commentSnapshot,
  children,
}: {
  commentSnapshot?: CommentSnapshot
  children: React.ReactNode
}) {
  return (
    <CommentSnapshotContext value={commentSnapshot ?? FALLBACK_COMMENT_SNAPSHOT}>{children}</CommentSnapshotContext>
  )
}

export const useCommentSnapshot = () => use(CommentSnapshotContext)
